import cl from "./Product.module.css";
import React, { useState, useContext } from "react";
import { NavLink } from "react-router-dom";

const Product = (props) => {
  const [style, setStyle] = useState(cl.add_to_cart);
  const [style2, setStyle2] = useState(cl.image);
  const [isAdded, setIsAdded] = useState(false);
  let hoveron = () => {
    setStyle(cl.add_to_cart_active);
    setStyle2(cl.image_hover);
  };

  let hoveroff = () => {
    setStyle(cl.add_to_cart);
    setStyle2(cl.image);
  };

  let onClick = () => {
    props.onAdd(props);
    setIsAdded(!isAdded);
  };
  let newPrice = ((props.oldPrice * (100 - props.discount)) / 100).toFixed(2);

  const image = props.images ? props.images[0] : null;

  return (
    <section className={cl.product}>
      <div className={cl.product_image_inner}>
        <div className={cl.product_image_container}>
          <NavLink to={props.path}>
            <img
              className={style2}
              src={image}
              onMouseEnter={hoveron}
              onMouseOut={hoveroff}
            />
          </NavLink>
        </div>
        <div className={cl.discount}>-{props.discount}%</div>
        <div
          className={style}
          onMouseEnter={hoveron}
          onMouseOut={hoveroff}
          onClick={onClick}
        >
          {!isAdded ? "ADD TO CART" : "✔ ADDED"}
        </div>
      </div>
      <div className={cl.profile}>
        <div className={cl.info}>
          <p>{props.name}</p>
          <div className={cl.price}>
            <p className={cl.old}>
              {props.currency}
              {props.oldPrice}
            </p>
            <p className={cl.new}>
              {props.currency}
              {newPrice}
            </p>
          </div>
        </div>
      </div>
      <div></div>
    </section>
  );
};

export default Product;
